export default "__VITE_ASSET__CXidlPoc__"